import { render, staticRenderFns } from "./SubFieldList.vue?vue&type=template&id=129538dd"
import script from "./SubFieldList.vue?vue&type=script&lang=js"
export * from "./SubFieldList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports